import { ajax } from "@utils";

export const notificationService = {
  /**
   * 取得推播紀錄列表
   * @key SearchConstructionNotificationByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  getAll: (constructionUuid, condition) => {
    return ajax
      .get(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/notifications`,
        {
          params: {
            ...condition
          }
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 新增推播
   * @key CreateConstructionNotificationByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} info - 推播資訊
   *
   * @returns
   */
  create: (constructionUuid, info) => {
    return ajax
      .post(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/notifications`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  }
};
